import { ArrowForwardIos } from '@interhyp/platform-icons';
import React, { useMemo } from 'react';
import { NoContent } from "./illustrations/NoContent.js";
import { NoSearchResults } from "./illustrations/NoSearchResults.js";
import { NoSelection } from "./illustrations/NoSelection.js";
import { Button } from "../button/Button.js";
import { Typography } from "../typography/Typography.js";
import styles from "./EmptyState.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EmptyState({
  variant,
  title,
  description,
  size = 'LARGE',
  action
}) {
  const component = useMemo(() => {
    switch (variant) {
      case 'NO_CONTENT':
        return /*#__PURE__*/_jsx(NoContent, {
          className: size === 'SMALL' ? styles.smallIcon : styles.largeIcon
        });
      case 'NO_SELECTION':
        return /*#__PURE__*/_jsx(NoSelection, {
          className: size === 'SMALL' ? styles.smallIcon : styles.largeIcon
        });
      case 'NO_SEARCH_RESULTS':
        return /*#__PURE__*/_jsx(NoSearchResults, {
          className: size === 'SMALL' ? styles.smallIcon : styles.largeIcon
        });
    }
  }, [size, variant]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.illustration,
      children: component
    }), /*#__PURE__*/_jsx("div", {
      className: styles.contentAligner,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx(Typography, {
          className: styles.title,
          variant: size === 'SMALL' ? 'h4' : 'h2',
          margin: false,
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "p",
          margin: false,
          children: description
        }), action && /*#__PURE__*/_jsx(Button, {
          className: styles.action,
          iconRight: !action.iconPlacement || action.iconPlacement === 'RIGHT' ? action.icon ?? ArrowForwardIos : undefined,
          iconLeft: action.iconPlacement === 'LEFT' ? action.icon ?? ArrowForwardIos : undefined,
          variant: "text",
          onClick: action.onClick,
          children: action.label
        })]
      })
    })]
  });
}